import React, { useMemo, useState } from 'react';
import { TreeItemChildren } from './TreeItemChildren';
import { useViewState } from '../tree/useViewState';
import { useTree } from '../tree/Tree';
import { useTreeEnvironment } from '../controlledEnvironment/ControlledTreeEnvironment';
import { useTreeItemRenderContext } from './useTreeItemRenderContext';
import { TreeItemRenamingInput } from './TreeItemRenamingInput';
export var TreeItem = function (props) {
    var _a, _b;
    var _c = useState(false), hasBeenRequested = _c[0], setHasBeenRequested = _c[1];
    var _d = useTree(), renderers = _d.renderers, treeInformation = _d.treeInformation, renamingItem = _d.renamingItem;
    var environment = useTreeEnvironment();
    var viewState = useViewState();
    var item = environment.items[props.itemIndex];
    var isExpanded = useMemo(function () { var _a; return (_a = viewState.expandedItems) === null || _a === void 0 ? void 0 : _a.includes(props.itemIndex); }, [props.itemIndex, viewState.expandedItems]);
    var renderContext = useTreeItemRenderContext(item);
    if (item === undefined || renderContext === undefined) {
        if (!hasBeenRequested) {
            setHasBeenRequested(true);
            (_a = environment.onMissingItems) === null || _a === void 0 ? void 0 : _a.call(environment, [props.itemIndex]);
        }
        return null;
    }
    var children = item.isFolder && isExpanded && item.children && (React.createElement(TreeItemChildren, { depth: props.depth + 1, parentId: props.itemIndex }, item.children));
    var title = environment.getItemTitle(item);
    var titleComponent = renamingItem === props.itemIndex ? (React.createElement(TreeItemRenamingInput, { itemIndex: props.itemIndex })) : (renderers.renderItemTitle({
        info: treeInformation,
        context: renderContext,
        title: title,
        item: item,
    }));
    var arrowComponent = renderers.renderItemArrow({
        info: treeInformation,
        context: renderContext,
        item: environment.items[props.itemIndex],
    });
    return ((_b = renderers.renderItem({
        item: environment.items[props.itemIndex],
        depth: props.depth,
        title: titleComponent,
        arrow: arrowComponent,
        context: renderContext,
        info: treeInformation,
        children: children,
    })) !== null && _b !== void 0 ? _b : null); // Type to use AllTreeRenderProps
};
